import { siteMetadata } from "../../gatsby-config"

export function setGeocodedLocations(setLocations){
  const addressIds = ['address_line1', 'locality', 'postal_code'];
  const addressComponents = {};
  for(let addressId of addressIds){
    const addressEl = document.getElementById(addressId);
    addressComponents[addressId] = addressEl && addressEl.value ? addressEl.value : "";
  }
  const params = {};
  const componentArr = ['administrative_area:OR', 'country:USA'];
  for(let component of Object.keys(addressComponents)){
    if(component === 'address_line1'){
      params.address = addressComponents[component];
    }
    else if (component !== 'locality' || (component === 'locality' && !addressComponents.postal_code)) {
      componentArr.push(`${component}:${addressComponents[component]}`)
    }
  }
  params.components = componentArr.join('|');
  const address = encodeURI(`${addressComponents.address_line1} ${addressComponents.locality} ${addressComponents.address_line1 || addressComponents.locality ? "OR" : ""} ${addressComponents.postal_code}`.trim());
  const handleGeocodeResponse = (data) => {
    setLocations(data.results.filter((result) => {
      return result.types &&
        (result.types.includes("premise") || result.types.includes("subpremise") || result.types.includes("street_address") || result.types.includes("locality") || result.types.includes("postal_code"));
    }));
  };
  const requestUrl = siteMetadata.drupalUrl;
  fetch(`${requestUrl}/tools/geolocate?${new URLSearchParams(params).toString()}`).then(response => response.json()).then(handleGeocodeResponse);
}
